import { IProductsQrType } from '@/models/generateQr.model';

export enum GenerateQrFields {
  STORES = 'stores',
  CATEGORIES = 'categories',
  PRODUCTS = 'products',
  REGION_ID = 'regionId',
  TYPE = 'type',
}

export type TGenerateQrFormValues = {
  [GenerateQrFields.STORES]: string[];
  [GenerateQrFields.CATEGORIES]: string[];
  [GenerateQrFields.PRODUCTS]: string[];
  [GenerateQrFields.REGION_ID]: string;
  [GenerateQrFields.TYPE]: IProductsQrType;
};
